<div class="container-fluid mb-4 p-4">
  <div class="row font-name">
    <div class="content d-flex align-items-center">
		 <button mat-icon-button (click)="goBack()" class="me-3 arrow-back">
        <mat-icon>arrow_back</mat-icon>
      </button>
	  <div>
      <h3 class="mb-1">My Learning</h3>
      <p class="mb-0">Track your progress and continue learning</p>
    </div>
    </div>
  </div>

    <ng-container *hasPermission="PermissionForStudents.DASHBOARD_STUDENT">
  <div class="container-fluid font-name">
    <ng-container *ngIf="isLoading; else pageContent">
      <div class="app-spinner">
        <mat-spinner diameter="60"></mat-spinner>
      </div>
    </ng-container>
    <ng-template #pageContent>
      <ng-container *ngIf="studentDashboardStats.length > 0; else showMessage">
        <div class="row font-name">
          <div class="col-12 col-sm-6 col-lg-3 mb-3" *ngFor="let studentsData of studentDashboardStats">
            <div class="dashboard-card">
              <div class="card-content">
                <div class="card-text">
                  <div class="icon-box" [style.background]="studentsData.bgColor">
                    <i class="bi" [ngClass]="studentsData.icon" [style.color]="studentsData.iconColor"></i>
                  </div>
                  <h2>{{ studentsData.studentCount || "0" }}</h2>
                </div>
              </div>
              <span>{{ studentsData.title || "N/A" }}</span>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #showMessage>
        <p class="text-center">No student dashboard available</p>
      </ng-template>
    </ng-template>
  </div>
  </ng-container>

  <!-- <div class="ready-learn mb-5 mt-2">
    <div class="learn-info p-4">
      <p>
        <span>Ready to continue?</span><br />
        Pick up where you left off
      </p>
    </div>
    <div class="p-4">
      <button
        type="button"
        class="btn-add"
        [routerLink]="['/student-dashboard/course-details']">
        <i class="bi bi-play-circle"></i>
        Resume Learning
      </button>
    </div>
  </div> -->

  <div class="tabs-container mb-4 font-name">
	<ng-container *hasPermission ="PermissionForStudents.COURSE_VIEW">
		<button
      class="tab"
      [class.active]="selectedTab === courseTabStatus.IN_PROGRESS"
      (click)="selectTab(courseTabStatus.IN_PROGRESS)">
      <i class="bi bi-hourglass-split"></i>
      In Progress
     </button>
	</ng-container>

	<ng-container *hasPermission="PermissionForStudents.COURSE_VIEW">
    <button
      class="tab"
      [class.active]="selectedTab === courseTabStatus.COMPLETE"
      (click)="selectTab(courseTabStatus.COMPLETE)">
      <i class="bi bi-check-circle"></i>
      Completed Course
    </button>

	</ng-container>
	<ng-container *hasPermission = "PermissionForStudents.QUIZ_VIEW">
	 <button
      class="tab"
      [class.active]="selectedTab === courseTabStatus.SUBMITTED"
      (click)="selectTab(courseTabStatus.SUBMITTED)">
      <i class="bi bi-clipboard-plus"></i>
      Quizzes Completed
    </button>
   </ng-container>
  </div>

  <div class="tab-content">
    <ng-container *ngIf="isCourseLoading">
      <div class="app-spinner">
        <mat-spinner diameter="60"></mat-spinner>
      </div>
    </ng-container>
    <div class="col-12" *ngIf="!isCourseLoading && filterCourses.length > 0">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3" *ngFor="let course of filterCourses">
          <div class="card font-name">
            <div class="card-top" [ngClass]="{ 'no-thumbnail': !course.course_thumbnail }"
              [ngStyle]="course.course_thumbnail ? {'background-image': 'url(' + course.course_thumbnail + ')' }  : {} ">
            </div>
            <div class="card-body">
              <h5 class="card-title text-truncate" matTooltip="{{ course.course_title }}">{{ course.course_title ||
                "N/A" }}</h5>
              <span>Progress</span>
              <div class="mini-progress">
                <div class="mini-progress-bar" [style.width.%]="course.progress_percentage"></div>
                <span class="mini-progress-text">{{course.progress_percentage % 1 === 0
                  ? (course.progress_percentage | number : "1.0-0")
                  : (course.progress_percentage | number : "1.0-2")}} %
                </span>
              </div>
              <div class="stats mb-3">
                <i class="bi bi-book"></i> {{course.total_units}} lessons
                <i class="bi bi-lightbulb"></i>{{course.total_published_quizzes}} quizzes
              </div>
              <ng-container *ngIf="
                  selectedTab === courseTabStatus.COMPLETE;
                  else showContinueBtn">
                <button class="btn-add w-100 mt-2" (click)="goToCourseDescriptionPage(course.course_id)">
                  View
                  <i class="bi bi-eye ms-1"></i>
                </button>
              </ng-container>
              <ng-template #showContinueBtn>
                <button class="btn-add w-100 mt-2" (click)="goToCourseDescriptionPage(course.course_id)">
                  Continue
                  <i class="bi bi-arrow-right-circle"></i>
                </button>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="text-center mt-3 font-name" *ngIf="page < totalCoursePages">
          <button class="btn-add" (click)="loadMore()" [disabled]="isCourseLoading">
            <ng-container *ngIf="isCourseLoading; else showBtnText">
              <span class="spinner-border spinner-border-sm"></span> Loading...
            </ng-container>
            <ng-template #showBtnText>Load More</ng-template>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="!isCourseLoading && filterCourses.length === 0">
      <div class="no-course font-name" *ngIf="selectedTab === courseTabStatus.IN_PROGRESS">
        <span>No courses in progress</span>
        <p>Start learning to see your progress here!</p>
        <button type="button" class="btn-add" routerLink="/student-dashboard/pro-course">
          Browser Courses
        </button>
      </div>

      <div class="tab-content font-name" *ngIf="selectedTab === courseTabStatus.COMPLETE">
        <div class="no-course">
          <span>No completed courses yet</span>
          <p>Keep learning to complete your first course!</p>
        </div>
      </div>
      <div class="no-course font-name" *ngIf="selectedTab === courseTabStatus.ENROLLED">
        <span>No courses started yet </span>
        <p>Start learning to see your progress here!</p>
        <button type="button" class="btn-add" routerLink="/student-dashboard/pro-course">
          Browser Courses
        </button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="selectedTab === courseTabStatus.SUBMITTED">
    <ng-container *ngIf="studentCompleteQuiz.length > 0; else noQuizzes">
      <div class="quiz-grid font-name">
        <div class="quiz-card" *ngFor="let studentQuiz of studentCompleteQuiz">
          <div class="quiz-header">
            <div class="quiz-icon">
              <i class="bi bi-lightning-fill"></i>
            </div>
            <span class="status"> {{studentQuiz.status}}</span>
          </div>

          <h3 class="quiz-title truncate" matTooltip="{{studentQuiz.quiz_name}}">{{studentQuiz.quiz_name}}</h3>

    <div class="quiz-meta">
      <div>
        <span>Date</span>
        <strong>{{studentQuiz.published_date | date:dateFormat}}</strong>
      </div>
      <div>
        <span>Score</span>
        <strong>{{studentQuiz.score}}</strong>
      </div>
    </div>
      
		<button
		*hasPermission="PermissionForStudents.QUIZ_RESULT"
		type="button"
        class="action-btn btn-success" (click)="viewQuizResult(studentQuiz)">
        <i class="bi bi-check-circle-fill"></i> View Result
      </button>

        </div>
      </div>
    </ng-container>
    <ng-template #noQuizzes>
      <div class="no-course text-center font-name">
        <span>No quizzes attempted yet</span>
        <p>Keep practicing to attempt your first quiz!</p>
      </div>
    </ng-template>
  </ng-container>
</div>